import { useState, useRef, useEffect } from 'react';
import LOGO from '../Assets/logo2.png';
import { FaLifeRing, FaUserCog } from 'react-icons/fa';
import { MdQuestionMark, MdOutlineEmail } from 'react-icons/md';
import { FaPhone, FaRegMessage } from 'react-icons/fa6';
import { GrSupport } from 'react-icons/gr';
import { IoBug } from 'react-icons/io5';
import { BsPatchCheck, BsFillBellFill } from 'react-icons/bs';
import Modal from '../modals/Modal';
import { useAppContext } from '../context/AppContext';
import axios from 'axios';

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const headerRef = useRef(null);
  const [reloadOpen, setReloadOpen] = useState(false);
  const { user, axiUrl, logout } = useAppContext();
  const [alerts, setAlerts] = useState([]);

  console.log(user);

  useEffect(() => {
    if (user?.systemupdate) {
      setAlerts([{ id: 1, alertMessage: 'System Update Available', action: handleClick }]);
    }
  }, [user]);

  console.log(alerts);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setIsNotificationOpen(false);
    setIsMessageOpen(false);
    setIsUserDropdownOpen(false);
  };

  const toggleNotification = () => {
    setIsNotificationOpen(!isNotificationOpen);
    setIsDropdownOpen(false);
    setIsMessageOpen(false);
    setIsUserDropdownOpen(false);
  };

  const toggleMessage = () => {
    setIsMessageOpen(!isMessageOpen);
    setIsDropdownOpen(false);
    setIsNotificationOpen(false);
    setIsUserDropdownOpen(false);
  };

  const toggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
    setIsDropdownOpen(false);
    setIsNotificationOpen(false);
    setIsMessageOpen(false);
  };

  const messageCount = 0;
  const notificationCount = alerts.length;

  const check = () => {
    console.log('ok');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        headerRef.current &&
        !headerRef.current.contains(event.target) &&
        (isDropdownOpen || isNotificationOpen || isMessageOpen || isUserDropdownOpen)
      ) {
        check();
        setIsDropdownOpen(false);
        setIsNotificationOpen(false);
        setIsMessageOpen(false);
        setIsUserDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen, isNotificationOpen, isMessageOpen, isUserDropdownOpen]);

  const handleClick = async () => {
    try {
      console.log('Starting system update for user:', user._id);
      setReloadOpen(true);
      setIsDropdownOpen(false);
      setIsNotificationOpen(false);
      setIsMessageOpen(false);
      setIsUserDropdownOpen(false);

      const response = await axios.post(
        `${axiUrl}/user/systemupdateoff`,
        { id: user._id },
      );
      console.log('API response:', response.data);

      if (response.data.status === 200) {
        console.log('API call successful, waiting 3 seconds before reload');
        await new Promise(resolve => setTimeout(resolve, 3000));
        console.log('Setting reloadOpen to false');
        setReloadOpen(false);
        console.log('Reloading page');
        window.location.reload(true);
      } else {
        throw new Error(`API response invalid: ${JSON.stringify(response.data)}`);
      }
    } catch (err) {
      console.error('Error during system update:', err);
      setReloadOpen(false);
      const errorMessage = err.code === 'ECONNABORTED'
        ? 'Request timed out. Please check your network or try again later.'
        : 'Failed to update system. Please try again.';
      alert(errorMessage);
    }
  };

  const userDropdownItems = [
    { name: 'My Profile', path: '/' },
    { name: 'Manage Users', path: '/' },
    { name: 'Logout', action: logout },
  ];

  return (
    <div ref={headerRef}>
      <Modal show={reloadOpen}>Updating System...</Modal>
      <header className="bg-gray-800 text-white p-4 flex justify-between items-center fixed top-0 left-0 right-0 z-1000">
        <div className="flex items-center">
          <img src={LOGO} alt="Logo" className="h-10 w-10 mr-2" />
          Lighnting Presort
        </div>

        <div className="flex items-center space-x-15 relative">
          <div className="relative">
            <button onClick={toggleMessage}>
              <FaRegMessage size={22} className="cursor-pointer hover:text-gray-300" />
              {messageCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {messageCount}
                </span>
              )}
            </button>
            {isMessageOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-gray-700 rounded-md shadow-lg py-1 z-20 px-4">
                <p className="text-center border-b-1 pb-3 mb-4">Recent Messages</p>
                <div>
                  <a href="#" className="block px-4 py-2 text-md text-white hover:bg-gray-600">
                    Job Submitted: 584596 - Processed
                  </a>
                </div>
                <div>
                  <a href="#" className="block px-4 py-2 text-md text-white hover:bg-gray-600">
                    Job Submitted: 1236598 - Processed
                  </a>
                </div>
                <div>
                  <a href="#" className="block px-4 py-2 text-md text-white hover:bg-gray-600">
                    Job Submitted: 458542_Iraq_A-Ribs - Processed
                  </a>
                </div>
              </div>
            )}
          </div>
          <div className="relative">
            <button onClick={toggleNotification}>
              <BsFillBellFill size={22} className="cursor-pointer hover:text-gray-300" />
              {notificationCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {notificationCount}
                </span>
              )}
            </button>
            {isNotificationOpen && (
              <div className="absolute right-0 mt-1 w-64 bg-gray-700 rounded-md shadow-lg py-1 z-20 px-4">
                <p className="text-center border-b-1 pb-3 mb-1">Recent Alerts</p>
                {alerts.length > 0 ? (
                  alerts.map((alert, index) => (
                    <div key={index} onClick={alert.action}>
                      <a href="#" className="block px-4 py-2 text-md text-white hover:bg-gray-600">
                        {alert.alertMessage}
                      </a>
                    </div>
                  ))
                ) : (
                  <p className="px-4 py-2 text-md text-white">No alerts available</p>
                )}
              </div>
            )}
          </div>
          <div className="relative">
            <button onClick={toggleDropdown}>
              <FaLifeRing size={22} className="cursor-pointer hover:text-gray-300" />
            </button>
            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-gray-700 rounded-md shadow-lg py-1 z-20 px-4">
                <p className="pl-3">Need HELP?</p>
                <p className="text-center border-b-1 pb-3 mb-4">Were Here</p>
                <div>
                  <MdQuestionMark size={22} className="inline-block m-0" />
                  <a href="#" className="inline-block px-6 py-2 text-md text-white hover:bg-gray-600">
                    FAQ's
                  </a>
                </div>
                <div>
                  <MdOutlineEmail size={22} className="inline-block m-0" />
                  <a href="#" className="inline-block px-6 py-2 text-md text-white hover:bg-gray-600">
                    Email Us
                  </a>
                </div>
                <div>
                  <FaPhone size={20} className="inline-block m-0" />
                  <a href="#" className="inline-block px-6 py-2 text-md text-white hover:bg-gray-600">
                    (800) Lightning
                  </a>
                </div>
                <div>
                  <GrSupport size={22} className="inline-block m-0" />
                  <a href="#" className="inline-block px-6 py-2 text-md text-white hover:bg-gray-600">
                    Support
                  </a>
                </div>
                <div>
                  <IoBug size={22} className="inline-block m-0" />
                  <a href="#" className="inline-block px-6 py-2 text-md text-white hover:bg-gray-600">
                    Report a bug
                  </a>
                </div>
                <div>
                  <BsPatchCheck size={22} className="inline-block m-0" />
                  <a href="#" className="inline-block px-6 py-2 text-md text-white hover:bg-gray-600">
                    Recent Updates
                  </a>
                </div>
                <div className="border-b-1 pb-3 mb-4">
                  <BsPatchCheck size={22} className="inline-block m-0" />
                  <a href="#" className="inline-block px-6 py-2 text-md text-white hover:bg-gray-600">
                    Share Your feedback!
                  </a>
                </div>
              </div>
            )}
          </div>
          <div className="relative -mt-1 -ml-5 mr-5">
            <button onClick={toggleUserDropdown}>
              <FaUserCog size={26} className="cursor-pointer hover:text-gray-300" />
            </button>
            {isUserDropdownOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-gray-700 rounded-md shadow-lg py-1 z-20 px-4">
             
                {userDropdownItems.map((item, index) => (
                  <div key={index}>
                    {item.action ? (
                      <button
                        onClick={item.action}
                        className="block w-full text-left px-4 py-2 text-md text-white hover:bg-gray-600"
                      >
                        {item.name}
                      </button>
                    ) : (
                      <a
                        href={item.path}
                        className="block px-4 py-2 text-md text-white hover:bg-gray-600"
                      >
                        {item.name}
                      </a>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;